require("source-map-support").install(), function (n, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("FormInputWrapper", [], e) : "object" == typeof exports ? exports.FormInputWrapper = e() : n.FormInputWrapper = e();
}(this, function () {
  return function (n) {
    var e = {};

    function t(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
    }

    return t.m = n, t.c = e, t.d = function (n, e, r) {
      t.o(n, e) || Object.defineProperty(n, e, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, t.t = function (n, e) {
      if (1 & e && (n = t(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var i in n) {
        t.d(r, i, function (e) {
          return n[e];
        }.bind(null, i));
      }
      return r;
    }, t.n = function (n) {
      var e = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return t.d(e, "a", e), e;
    }, t.o = function (n, e) {
      return Object.prototype.hasOwnProperty.call(n, e);
    }, t.p = "/", t(t.s = 354);
  }({
    0: function _(n, e) {
      n.exports = require("react");
    },
    1: function _(n, e) {
      n.exports = require("prop-types");
    },
    10: function _(n, e, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          a = t(1),
          o = t.n(a),
          u = t(2);

      function c() {
        var n = i()(["\n  align-content: ", ";\n  align-items: ", ";\n  align-self: ", ";\n  display: ", ";\n  flex-basis: ", ";\n  flex-direction: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n  order: ", ";\n  overflow: ", ";\n"]);
        return c = function c() {
          return n;
        }, n;
      }

      var s = t.n(u).a.div(c(), function (n) {
        return n.alignContent;
      }, function (n) {
        return n.alignItems;
      }, function (n) {
        return n.alignSelf;
      }, function (n) {
        return n.inline ? "inline-flex" : "flex";
      }, function (n) {
        return n.flexBasis;
      }, function (n) {
        return n.flexDirection;
      }, function (n) {
        return n.flexGrow;
      }, function (n) {
        return n.flexShrink;
      }, function (n) {
        return n.flexWrap ? "wrap" : "nowrap";
      }, function (n) {
        return n.justifyContent;
      }, function (n) {
        return n.order;
      }, function (n) {
        return n.overflow;
      });
      s.propTypes = {
        alignContent: o.a.string,
        alignItems: o.a.string,
        alignSelf: o.a.string,
        flexBasis: o.a.oneOfType([o.a.number, o.a.string]),
        flexDirection: o.a.string,
        flexGrow: o.a.number,
        flexShrink: o.a.number,
        flexWrap: o.a.bool,
        inline: o.a.bool,
        justifyContent: o.a.string,
        overflow: o.a.string,
        order: o.a.number
      }, s.defaultProps = {
        alignContent: "stretch",
        alignItems: "stretch",
        alignSelf: "auto",
        flexBasis: "auto",
        flexDirection: "row",
        flexGrow: 0,
        flexShrink: 1,
        flexWrap: !1,
        inline: !1,
        justifyContent: "flex-start",
        order: 0,
        overflow: "hidden"
      }, s.displayName = "FlexContainer", e.a = s;
    },
    11: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/objectWithoutProperties");
    },
    12: function _(n, e) {
      n.exports = require("@fortawesome/react-fontawesome");
    },
    13: function _(n, e, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          a = t(0),
          o = t.n(a),
          u = t(1),
          c = t.n(u),
          s = t(2),
          f = t.n(s),
          l = t(7);

      function d() {
        var n = i()(["\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
        return d = function d() {
          return n;
        }, n;
      }

      var p = f()(function (n) {
        var e = n.children,
            t = n.className;
        return o.a.Children.only(o.a.cloneElement(e, {
          className: t
        }));
      })(d(), function (n) {
        var e = n.margin;
        return Object(l.a)({
          attribute: "margin",
          value: e
        });
      }, function (n) {
        var e = n.marginTop;
        return Object(l.a)({
          attribute: "margin-top",
          value: e
        });
      }, function (n) {
        var e = n.marginBottom;
        return Object(l.a)({
          attribute: "margin-bottom",
          value: e
        });
      }, function (n) {
        var e = n.marginLeft;
        return Object(l.a)({
          attribute: "margin-left",
          value: e
        });
      }, function (n) {
        var e = n.marginRight;
        return Object(l.a)({
          attribute: "margin-right",
          value: e
        });
      });
      p.propTypes = {
        margin: c.a.oneOfType([c.a.string, c.a.number]),
        marginTop: c.a.oneOfType([c.a.string, c.a.number]),
        marginBottom: c.a.oneOfType([c.a.string, c.a.number]),
        marginLeft: c.a.oneOfType([c.a.string, c.a.number]),
        marginRight: c.a.oneOfType([c.a.string, c.a.number])
      }, e.a = p;
    },
    14: function _(n, e) {
      n.exports = require("lodash.memoize");
    },
    15: function _(n, e, t) {
      "use strict";

      t.d(e, "g", function () {
        return r;
      }), t.d(e, "c", function () {
        return i;
      }), t.d(e, "b", function () {
        return o;
      }), t.d(e, "d", function () {
        return u;
      }), t.d(e, "a", function () {
        return a;
      }), t.d(e, "e", function () {
        return c;
      }), t.d(e, "f", function () {
        return s;
      });
      var r = 150,
          i = 250,
          a = 500,
          o = 40,
          u = "cubic-bezier(0.25, 0.01, 0.25, 1)",
          c = [.25, .01, .25, 1],
          s = 150;
    },
    178: function _(n, e, t) {
      "use strict";

      t.r(e);
      var r = t(99);
      e.default = r.a;
    },
    19: function _(n, e, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          a = t(1),
          o = t.n(a),
          u = t(2);

      function c() {
        var n = i()(["\n  order: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-basis: ", ";\n  align-self: ", ";\n"]);
        return c = function c() {
          return n;
        }, n;
      }

      var s = t.n(u).a.div(c(), function (n) {
        return n.order;
      }, function (n) {
        return n.flexGrow;
      }, function (n) {
        return n.flexShrink;
      }, function (n) {
        return n.flexBasis;
      }, function (n) {
        return n.alignSelf;
      });
      s.propTypes = {
        order: o.a.number,
        flexGrow: o.a.number,
        flexShrink: o.a.number,
        flexBasis: o.a.oneOfType([o.a.number, o.a.string]),
        alignSelf: o.a.string
      }, s.defaultProps = {
        order: 0,
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: "auto",
        alignSelf: "auto"
      }, e.a = s;
    },
    2: function _(n, e) {
      n.exports = require("styled-components");
    },
    29: function _(n, e) {
      n.exports = require("react-transition-group/Transition");
    },
    3: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    354: function _(n, e, t) {
      n.exports = t(178);
    },
    4: function _(n) {
      n.exports = JSON.parse('{"white":"#ffffff","brand":"#0d51ff","brand10":"#e6edff","brand20":"#c5d2f5","brand40":"#96b1f7","brand60":"#6992fa","brand80":"#3a71fc","brand120":"#0a40cc","brand140":"#073099","brand160":"#052066","brand180":"#021033","grey":"#475b68","grey10":"#f8f8f8","grey20":"#f0f0f0","grey40":"#bbc3ca","grey60":"#919da4","grey80":"#6c7c86","grey120":"#384853","grey140":"#2a363e","grey160":"#1c2429","grey180":"#0e1214","success":"#00ab5b","successhover":"#008848","successlight":"#66cd9d","successbackground":"#e5f6ee","warninghover":"#cc9c00","warning":"#ffc400","warninglight":"#ffdc66","warningabsence":"#ffedb2","warningbackground":"#fff9e6","alerthover":"#cc180b","alert":"#ff1e0e","alertlight":"#ff786e","alertbackground":"#ffe8e6","infohover":"#b01863","info":"#dc1e7c","infolight":"#ea78b0","infobackground":"#fbe8f2","supporthover":"#583ac3","support":"#6e49f4","supportlight":"#a892f8","supportbackground":"#f0ecfe","boxshadowmedium":"rgba(71, 91, 104, 0.1)","modaloverlay":"rgba(2, 16, 51, 0.5)","transparent":"transparent"}');
    },
    40: function _(n, e, t) {
      "use strict";

      t.d(e, "f", function () {
        return r;
      }), t.d(e, "a", function () {
        return i;
      }), t.d(e, "e", function () {
        return a;
      }), t.d(e, "c", function () {
        return o;
      }), t.d(e, "d", function () {
        return u;
      }), t.d(e, "b", function () {
        return c;
      });
      var r = 10,
          i = 20,
          a = 40,
          o = 10,
          u = 4,
          c = 400;
    },
    44: function _(n, e, t) {
      "use strict";

      var r = t(6),
          i = t.n(r),
          a = t(0),
          o = t.n(a),
          u = t(29),
          c = t.n(u),
          s = t(15);

      function f(n, e) {
        var t = Object.keys(n);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(n);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          })), t.push.apply(t, r);
        }

        return t;
      }

      function l(n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = null != arguments[e] ? arguments[e] : {};
          e % 2 ? f(Object(t), !0).forEach(function (e) {
            i()(n, e, t[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : f(Object(t)).forEach(function (e) {
            Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
          });
        }

        return n;
      }

      var d = {
        transition: "opacity ".concat(s.g, "ms ease-in-out"),
        opacity: 0,
        willChange: "opacity",
        width: "inherit"
      },
          p = {
        entered: {
          opacity: 1
        },
        exiting: {
          opacity: 0
        }
      },
          g = function g(n) {
        var e = n.show,
            t = n.children;
        return o.a.createElement(c.a, {
          in: e,
          timeout: {
            enter: 0,
            exit: s.g
          },
          mountOnEnter: !0,
          unmountOnExit: !0
        }, function (n) {
          return o.a.createElement("div", {
            style: l({}, d, {}, p[n])
          }, t);
        });
      };

      g.displayName = "FadeTransition", e.a = g;
    },
    5: function _(n, e, t) {
      "use strict";

      t.d(e, "a", function () {
        return b;
      }), t.d(e, "e", function () {
        return a;
      }), t.d(e, "j", function () {
        return o;
      }), t.d(e, "f", function () {
        return u;
      }), t.d(e, "g", function () {
        return c;
      }), t.d(e, "i", function () {
        return l;
      }), t.d(e, "c", function () {
        return d;
      }), t.d(e, "k", function () {
        return d;
      }), t.d(e, "l", function () {
        return p;
      }), t.d(e, "b", function () {
        return g;
      }), t.d(e, "d", function () {
        return m;
      }), t.d(e, "h", function () {
        return f;
      });

      var r = t(4),
          i = t(9),
          a = function a(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (n) {
          case "primary":
            return e.brand;

          case "secondary":
          case "normal":
          default:
            return e.grey;

          case "info":
            return e.info;

          case "support":
            return e.support;

          case "success":
            return e.success;

          case "warning":
            return e.warning;

          case "alert":
            return e.alert;

          case "brand160":
            return e.brand160;

          case "white":
            return e.white;
        }
      },
          o = function o(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (n) {
          case "primary":
            return e.brand60;

          case "secondary":
          case "normal":
          default:
            return e.grey40;

          case "info":
            return e.infolight;

          case "support":
            return e.supportlight;

          case "success":
            return e.successlight;

          case "warning":
            return e.warninglight;

          case "alert":
            return e.alertlight;

          case "grey20":
          case "white":
            return e.grey20;
        }
      },
          u = function u(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (n) {
          case "primary":
            return e.brand120;

          case "secondary":
          case "normal":
          default:
            return e.grey140;

          case "info":
            return e.infohover;

          case "support":
            return e.supporthover;

          case "success":
            return e.successhover;

          case "warning":
            return e.warninghover;

          case "alert":
            return e.alerthover;

          case "white":
            return e.grey20;
        }
      },
          c = function c(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i;

        switch (n) {
          case "xxs":
            return e.Body4;

          case "xs":
            return e.Body3;

          case "sm":
            return e.Body2;

          case "md":
          default:
            return e.Body1;

          case "lg":
            return e.H5;

          case "xl":
            return e.H4;

          case "xxl":
            return e.H3;

          case "xxxl":
            return e.H2;

          case "xxxxl":
            return e.H1;
        }
      },
          s = Object.freeze({
        xs: 24,
        sm: 30,
        md: 40,
        lg: 50
      }),
          f = function f(n) {
        return s[n] || s.md;
      },
          l = function l(n, e) {
        var t = {
          padding: {
            vertical: 0,
            horizontal: 10
          },
          font: {},
          supportFont: {},
          height: 0
        };

        switch (n) {
          case "xs":
            t.padding.vertical = 6, t.font = e.Body3, t.supportFont = e.Body4;
            break;

          case "sm":
            t.padding.vertical = 8, t.font = e.Body1, t.supportFont = e.Body3;
            break;

          default:
          case "md":
            t.padding.vertical = 12, t.font = e.Body1, t.supportFont = e.Body3;
            break;

          case "lg":
            t.padding.vertical = 17, t.font = e.Body1, t.supportFont = e.Body3;
        }

        return t.height = f(n), t;
      },
          d = function d(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (n) {
          case "primary":
            return e.brand10;

          case "info":
            return e.infobackground;

          case "support":
            return e.supportbackground;

          case "success":
            return e.successbackground;

          case "warning":
            return e.warningbackground;

          case "alert":
            return e.alertbackground;

          case "normal":
          default:
            return e.white;
        }
      },
          p = function p(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (n) {
          case "warning":
            return e.brand160;

          case "info":
          case "support":
          case "success":
          case "alert":
          default:
            return e.white;
        }
      },
          g = function g(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (n) {
          case "info":
            return e.info;

          case "support":
            return e.support;

          case "success":
            return e.success;

          case "warning":
            return e.warning;

          case "alert":
            return e.alert;

          default:
            return e.brand;
        }
      },
          m = function m(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (n) {
          case "info":
            return e.info;

          case "support":
            return e.support;

          case "success":
            return e.success;

          case "warning":
            return e.warning;

          case "alert":
            return e.alert;

          default:
            return e.brand;
        }
      },
          b = new Map([[0, "rgb(110,73,244)"], [1, "#098256"], [2, "#7300B3"], [3, "#052066"], [4, "#6E49F4"], [5, "#0A40CC"], [6, "#FFB300"], [7, "#FF1E0E"], [8, "#038F00"], [9, "#CC34AF"], [10, "#11AEEF"], [11, "#475B68"], [12, "#DC1E7C"], [13, "#30C881"], [14, "#FF6A12"], [15, "#2D9898"]]);
    },
    50: function _(n, e, t) {
      "use strict";

      t.d(e, "b", function () {
        return p;
      }), t.d(e, "c", function () {
        return g;
      }), t.d(e, "d", function () {
        return m;
      }), t.d(e, "a", function () {
        return d;
      });
      var r = t(3),
          i = t.n(r),
          a = t(2),
          o = t.n(a),
          u = t(40);

      function c() {
        var n = i()(["\n  margin-top: ", "px;\n"]);
        return c = function c() {
          return n;
        }, n;
      }

      function s() {
        var n = i()(["\n  width: 100%;\n  margin-right: ", "px;\n  margin-left: ", "px;\n"]);
        return s = function s() {
          return n;
        }, n;
      }

      function f() {
        var n = i()(["\n  margin-bottom: ", "px;\n  margin-top: ", "px;\n  max-width: ", ";\n"]);
        return f = function f() {
          return n;
        }, n;
      }

      function l() {
        var n = i()(["\n  max-width: ", ";\n"]);
        return l = function l() {
          return n;
        }, n;
      }

      var d = o.a.div(l(), function (n) {
        return n.fitsContainer ? "none" : "".concat(u.b, "px");
      });
      d.displayName = "FormContainer";
      var p = o.a.div(f(), function (n) {
        var e = n.marginBottom,
            t = n.compact;
        return function (n) {
          if (n || 0 === n) return "".concat(n);
        }(e) || (t ? u.a : u.e);
      }, function (n) {
        return n.marginTop;
      }, function (n) {
        var e = n.width;
        return n.fitsContainer ? "none" : "".concat(e, "px");
      });
      p.displayName = "FormInputContainer";
      var g = o.a.div(s(), u.c, function (n) {
        return n.indent ? u.c : 0;
      });
      g.displayName = "InputContainer";
      var m = o.a.div(c(), u.f);
      m.displayName = "Spacer";
    },
    6: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/defineProperty");
    },
    63: function _(n, e) {
      n.exports = require("@fortawesome/pro-light-svg-icons");
    },
    67: function _(n, e, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          a = t(1),
          o = t.n(a),
          u = t(2),
          c = t.n(u);

      function s() {
        var n = i()(["\n  cursor: wait;\n  width: ", ";\n  height: ", ";\n  position: relative;\n  border-radius: 4px;\n\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: ", ";\n  animation-timing-function: linear;\n\n  background: ", ";\n  background: linear-gradient(to right, ", " 8%, ", " 18%, ", " 33%);\n  background-size: ", "px 104px;\n"]);
        return s = function s() {
          return n;
        }, n;
      }

      function f() {
        var n = i()(["\n  0% {\n    background-position: -", "px 0;\n  }\n  100% {\n    background-position: ", "px 0;\n  }\n"]);
        return f = function f() {
          return n;
        }, n;
      }

      var l = Object(u.keyframes)(f(), 400, 400),
          d = function d(n) {
        return "number" == typeof n ? "".concat(n, "px") : n;
      },
          p = function p(n) {
        return n.theme.colors.grey20;
      },
          g = c.a.div(s(), function (n) {
        var e = n.width;
        return d(e);
      }, function (n) {
        var e = n.height;
        return d(e);
      }, l, p, p, "#e3e3e3", p, 800);

      g.propTypes = {
        height: o.a.oneOfType([o.a.string, o.a.number]).isRequired,
        width: o.a.oneOfType([o.a.string, o.a.number])
      }, g.defaultProps = {
        width: "100%"
      }, e.a = g;
    },
    7: function _(n, e, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          a = t(2);

      function o() {
        var n = i()(["", ": ", ""]);
        return o = function o() {
          return n;
        }, n;
      }

      function u() {
        var n = i()(["", ": ", "px"]);
        return u = function u() {
          return n;
        }, n;
      }

      e.a = function (n) {
        var e = n.attribute,
            t = n.value;

        if (void 0 !== t) {
          if ("number" == typeof t) return Object(a.css)(u(), e, t);
          if ("string" == typeof t) return Object(a.css)(o(), e, t);
          throw new Error("".concat(t, " is not of valid type for ").concat(e, ".\n      prop can either number or string"));
        }
      };
    },
    73: function _(n, e, t) {
      "use strict";

      var r = t(6),
          i = t.n(r),
          a = t(11),
          o = t.n(a),
          u = t(3),
          c = t.n(u),
          s = t(0),
          f = t.n(s),
          l = t(2),
          d = t.n(l),
          p = t(12),
          g = t(63),
          m = t(10),
          b = t(19),
          y = t(5);

      function h() {
        var n = c()(["\n  line-height: 16px;\n  hyphens: auto;\n  margin-left: 30px;\n"]);
        return h = function h() {
          return n;
        }, n;
      }

      function v() {
        var n = c()(["\n  height: 20px;\n  min-width: 20px;\n\n  line-height: 16px;\n  position: absolute;\n  top: 9px;\n  left: 9px;\n"]);
        return v = function v() {
          return n;
        }, n;
      }

      function x() {
        var n = c()(["\n  min-height: 40px;\n  padding: 9px;\n  position: relative;\n\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  border-radius: 3px;\n\n  color: ", ";\n  background-color: ", ";\n\n  transition-duration: .15s;\n  transition-timing-function: ease-in-out;\n  transition-property: background-color, border;\n"]);
        return x = function x() {
          return n;
        }, n;
      }

      function w(n, e) {
        var t = Object.keys(n);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(n);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          })), t.push.apply(t, r);
        }

        return t;
      }

      function O() {
        var n = c()(["\n  position: absolute;\n  height: 100%;\n\n  line-height: 16px;\n  opacity: ", ";\n  color: ", ";\n\n  transition-duration: .15s;\n  transition-timing-function: ease-in-out;\n  transition-property: color, opacity;\n"]);
        return O = function O() {
          return n;
        }, n;
      }

      var j = d()(function (n) {
        var e = n.icon,
            t = (n.uistyle, n.currentUistyle, o()(n, ["icon", "uistyle", "currentUistyle"]));
        return f.a.createElement(p.FontAwesomeIcon, function (n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = null != arguments[e] ? arguments[e] : {};
            e % 2 ? w(Object(t), !0).forEach(function (e) {
              i()(n, e, t[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : w(Object(t)).forEach(function (e) {
              Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
            });
          }

          return n;
        }({}, t, {
          icon: e,
          fixedWidth: !0
        }));
      })(O(), function (n) {
        var e = n.uistyle,
            t = n.currentUistyle;
        return Number(e === t);
      }, function (n) {
        var e = n.uistyle;
        return Object(y.e)(e);
      }),
          E = d()(m.a).attrs({
        alignItems: "center"
      })(x(), function (n) {
        var e = n.uistyle;
        return Object(y.e)(e);
      }, function (n) {
        return n.theme.colors.grey;
      }, function (n) {
        var e = n.uistyle;
        return Object(y.c)(e);
      }),
          k = d()(b.a)(v()),
          S = d()(b.a)(h()),
          F = [{
        uistyle: "success",
        icon: g.faCheckCircle
      }, {
        uistyle: "warning",
        icon: g.faBell
      }, {
        uistyle: "alert",
        icon: g.faExclamationTriangle
      }],
          B = function B(n) {
        var e = n.children,
            t = n.uistyle;
        return f.a.createElement(E, {
          uistyle: t
        }, f.a.createElement(k, null, F.map(function (n) {
          var e = n.uistyle,
              r = n.icon;
          return f.a.createElement(j, {
            icon: r,
            uistyle: e,
            currentUistyle: t,
            key: e
          });
        })), f.a.createElement(S, null, e));
      };

      B.defaultProps = {
        uistyle: "success"
      }, e.a = B;
    },
    8: function _(n, e, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          a = t(2),
          o = t.n(a),
          u = t(1),
          c = t.n(u),
          s = t(14),
          f = t.n(s),
          l = t(5);

      function d() {
        var n = i()(["\n    color: ", ";\n  "]);
        return d = function d() {
          return n;
        }, n;
      }

      function p() {
        var n = i()(["\n    line-height: ", "px;\n    font-size: ", "px;\n    font-family: ", ";\n  "]);
        return p = function p() {
          return n;
        }, n;
      }

      var g = f()(function (n) {
        var e = n.theme.fonts,
            t = n.size,
            r = Object(l.g)(t, e);
        return Object(a.css)(p(), r.lineHeight, r.fontSize, r.fontFamily);
      }, function (n) {
        return n.size;
      }),
          m = f()(function (n) {
        var e = n.lighter,
            t = n.theme.colors,
            r = n.uistyle,
            i = e ? Object(l.j)(r, t) : Object(l.e)(r, t);
        return Object(a.css)(d(), i);
      }, function (n) {
        var e = n.lighter,
            t = n.uistyle;
        return "".concat(e, "-").concat(t);
      });

      function b() {
        var n = i()(["\n  transition: 0.15s ease-in-out color;\n  ", "\n  ", "\n  font-weight: ", ";\n\n  padding: 0;\n  margin: 0;\n"]);
        return b = function b() {
          return n;
        }, n;
      }

      var y = o.a.p.attrs({
        children: function children(n) {
          return n.children || n.text;
        }
      })(b(), m, g, function (n) {
        return n.weight;
      });
      y.propTypes = {
        uistyle: c.a.string,
        size: c.a.oneOf(["xxl", "xl", "lg", "md", "sm", "xs", "xxs"]),
        lighter: c.a.bool,
        weight: c.a.oneOf(["normal", "bold", 600])
      }, y.defaultProps = {
        uistyle: "normal",
        size: "md",
        lighter: !1,
        weight: "normal"
      }, y.displayName = "Text";
      e.a = y;
    },
    9: function _(n) {
      n.exports = JSON.parse('{"H1":{"fontFamily":"URWGeometric","fontSize":46,"lineHeight":64},"H2":{"fontFamily":"URWGeometric","fontSize":38,"lineHeight":54},"H3":{"fontFamily":"URWGeometric","fontSize":26,"lineHeight":36},"H4":{"fontFamily":"URWGeometric","fontSize":20,"lineHeight":28},"H5":{"fontFamily":"URWGeometric","fontSize":18,"lineHeight":26},"Body1":{"fontFamily":"URWGeometric","fontSize":16,"lineHeight":22},"Body2":{"fontFamily":"URWGeometric","fontSize":14,"lineHeight":20},"Body3":{"fontFamily":"URWGeometric","fontSize":12,"lineHeight":16},"Body4":{"fontFamily":"URWGeometric","fontSize":10,"lineHeight":14}}');
    },
    92: function _(n, e, t) {
      "use strict";

      var r = t(0),
          i = t.n(r),
          a = t(5),
          o = t(67),
          u = function u(n) {
        var e = n.size,
            t = n.width,
            r = Object(a.h)(e);
        return i.a.createElement(o.a, {
          height: r,
          width: t
        });
      };

      u.defaultProps = {
        size: "md",
        width: 300
      }, e.a = u;
    },
    99: function _(n, e, t) {
      "use strict";

      t.d(e, "b", function () {
        return b;
      });

      var r = t(0),
          i = t.n(r),
          a = t(1),
          o = t.n(a),
          u = t(8),
          c = t(44),
          s = t(73),
          f = t(10),
          l = t(13),
          d = t(92),
          p = t(50),
          g = t(40),
          m = function m(n) {
        var e,
            t = n.label,
            r = n.children,
            a = n.indent,
            o = n.width,
            m = n.compact,
            b = n.validationMessage,
            y = n.validationStyle,
            h = n.helpText,
            v = n.labelComponent,
            x = n.required,
            w = n.loading,
            O = n.marginBottom,
            j = n.fitsContainer;
        return e = w ? i.a.createElement(d.a, {
          width: o
        }) : i.a.createElement(i.a.Fragment, null, r, i.a.createElement(c.a, {
          show: b && "" !== b
        }, i.a.createElement(p.d, null), i.a.createElement(s.a, {
          uistyle: y
        }, b)), h && "" !== h && i.a.createElement(i.a.Fragment, null, i.a.createElement(p.d, null), i.a.createElement(u.a, {
          text: h
        }))), i.a.createElement(p.a, {
          fitsContainer: j
        }, i.a.createElement(p.b, {
          compact: m,
          width: o,
          marginBottom: O,
          fitsContainer: j
        }, i.a.createElement(f.a, {
          overflow: "visible",
          flexDirection: "column"
        }, i.a.createElement(l.a, {
          marginBottom: g.d
        }, i.a.createElement(f.a, null, v ? i.a.createElement(v) : [t && i.a.createElement(u.a, {
          text: t,
          weight: 600,
          key: "label"
        }), x && i.a.createElement(u.a, {
          text: "*",
          weight: 600,
          uistyle: "alert",
          key: "required"
        })])), i.a.createElement(p.c, {
          indent: a
        }, e))));
      },
          b = (o.a.string, o.a.oneOfType([o.a.node, o.a.arrayOf(o.a.node)]).isRequired, o.a.bool, o.a.string, o.a.oneOf([400, 300, 200, 100]), o.a.bool, o.a.node, o.a.oneOf(["success", "alert"]), o.a.node, o.a.bool, o.a.bool, o.a.oneOfType([o.a.string, o.a.number]), o.a.bool, {
        label: null,
        indent: !1,
        helpText: null,
        width: 300,
        compact: !1,
        validationMessage: null,
        validationStyle: null,
        labelComponent: null,
        required: !1,
        loading: !1,
        marginBottom: null,
        fitsContainer: !1
      });

      m.defaultProps = b, e.a = m;
    }
  });
});